export default class CheckPredefinedComment
{
    constructor() {
      this.id = null
      this.check_id = null
      this.status = ''
      this.text = ''
    }
}
